import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Modal } from '@els/els-react--modal';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import ImportFileModalContent from './Components/ImportFileModalContent';
import ImportFileModalFooter from './Components/ImportFileModalFooter';

import './ImportFileModal.scss';

function ImportFileModal({ isRt = false, ...props }) {
  const { isLoading, initialize, close, doImport, uploadedFile, importFile, clearImport } = props;
  const history = useHistory();

  useEffect(() => {
    initialize(history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal id="import-file-modal" className="import-file-modal" onClose={close} shouldPreventClickOverlayToClose>
      <div className="import-file-modal__header">
        <h4>Import File</h4>
      </div>
      {isLoading && <SimpleSpinner id="search-import-file" />}
      <ImportFileModalContent importFile={importFile} uploadedFile={uploadedFile} isRt={isRt} />
      <ImportFileModalFooter onImport={doImport} uploadedFile={uploadedFile} onClearImportFile={clearImport} />
    </Modal>
  );
}

ImportFileModal.propTypes = {
  isRt: PropTypes.bool,
  isLoading: PropTypes.bool,
  initialize: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  doImport: PropTypes.func.isRequired,
  importFile: PropTypes.func.isRequired,
  clearImport: PropTypes.func.isRequired,
  uploadedFile: PropTypes.object,
};

export default ImportFileModal;
